import * as React from "react";
import { RouterProvider } from "@tanstack/react-router";
import { Interactions } from "./providers/interactions.provider.tsx";
import { PracticeProvider } from "./providers/practice.provider.tsx";
import { PromptDialogProvider } from "./providers/prompt-dialog.provider.tsx";
import { router } from "./router.tsx";

export function AppRoot() {
  const I_ = Interactions;
  return (
    <PracticeProvider>
      <I_.ToastProvider>
        <I_.PatientProvider>
          <I_.DialogProvider>
            <PromptDialogProvider>
              <RouterProvider router={router} />
            </PromptDialogProvider>
          </I_.DialogProvider>
        </I_.PatientProvider>
      </I_.ToastProvider>
    </PracticeProvider>
  );
}
